<div class="container" style="margin-top: 6em;">
  <h1>PAGINA NO ENCONTRADA</h1>
  <a class="btn btn-sm btn-success" style="color: white;" (click)="goPortal()">Ir al Portal</a>
</div>
